import React from 'react'

const SvgAngleDown = props => (
  <svg width='1em' height='1em' viewBox='0 0 12 6' {...props}>
    <path fill='currentColor' d='M6 5.991a.48.48 0 0 1-.34-.141L.5.689l.681-.68L6 4.828 10.819.009 11.5.69 6.34 5.85a.48.48 0 0 1-.34.14v.001z' />
  </svg>
)

export default SvgAngleDown
